export enum EventsNames {
  componentError = 'Component error',
  unknownNetworkError = 'Unknown Network Error',
  networkStatusOnline = 'Network status is online',
  networkStatusOffline = 'Network status is offline',

  // Components
  submitEditDownPaymentPopup = 'Submit Edit Down Payment Popup',
  cancelEditDownPaymentPopup = 'Cancel Edit Down Payment Popup',

  // mx
  mxHigherAmountRequest = 'Get higher amount',
  mxConnectUrlRequest = 'Get mx connection URL',

  // Loan Application
  getLoanApplicationUrl = 'Get loan application URL',

  // iovation
  saveIovationBlackbox = 'save_iovation_bb',
  savedIovationBlackboxSuccessfully = 'Saved Iovation Blackbox Successfully',
  saveIovationBlackboxFailed = 'Save Iovation Blackbox Failed',
  saveIovationBlackboxRetry = 'Saved Iovation Blackbox Retry',
}
